module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 025.3b9f2b67.jpg";